import React from "react";
import { Div, BigOutlineButton, BigFilledButton } from "components/Base";
import { noop } from "utils/General";
import css from "./styles.scss";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";

const Footer = ({
  onConfirm = noop,
  onCancel = noop,
  processing = false,
  disableConfirmButton = false
}) => {
  const display = useDisplay();
  return (
    <Div display={display} px={6} py={4} className={css.footer}>
      <BigFilledButton
        className="accentable-primary-button"
        mr={2}
        onClick={onConfirm}
        disabled={processing ? true : disableConfirmButton}
      >
        {processing ? "Saving..." : "Save"}
      </BigFilledButton>
      <BigOutlineButton width={100} onClick={onCancel}>
        Cancel
      </BigOutlineButton>
    </Div>
  );
};

export default Footer;
